import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import FloatingCart from "@/components/layout/FloatingCart";
import FloatingWhatsApp from "@/components/layout/FloatingWhatsApp";
import TrackOrder from "@/components/home/TrackOrder";
import SEOHead from "@/components/SEOHead";

const TrackOrderPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Track Your Order"
        description="Track your Bait Al-Teeb order status in real-time. Enter your email or phone number to see your order progress."
        canonical="https://bait-al-teeb-essence.lovable.app/track-order"
      />
      <Navbar />
      <FloatingCart />
      <FloatingWhatsApp />
      <main className="pt-24">
        <TrackOrder />
      </main>
      <Footer />
    </div>
  );
};

export default TrackOrderPage;
